var BaseView = require('./abstract/template');
var UserInfoFactory = require('../../../../factory/user-info');
var ProjectFacade = require('../../../../facade/project/project');

module.exports = BaseView.extend({
  height: null,
  template: require('./templates/template.hbs'),
  designAddedEvent: 'template.update.designed',

  events: {
    'click .base': 'addEvent',
    'click .options li[data-type="this-page"]': 'addEvent',
    'click .options li[data-type="new-page"]': 'addToNewPageEvent'
  },

  addEvent: function (event) {
    event.stopPropagation();

    if (this.design) {
      var isLocked = this.design['is_premium'] === '1' && !this.canUse;
      this.keepImages = true;

      isLocked
        ? this.displayLockedTemplateModal()
        : this._addEvent();
    }
  },

  addToNewPageEvent: function (event) {
    event.stopPropagation();

    if (this.design) {
      var isLocked = this.design['is_premium'] === '1' && !this.canUse;
      this.keepImages = false;

      isLocked
        ? this.displayLockedTemplateModal()
        : ProjectFacade.handle('design', 'add', { quiet: true })
          .then(_.bind(this._addEvent, this));
    }
  },

  displayLockedTemplateModal: function () {
    INKIVE.Helpers.displaySubscriptionModal('tool.templates.helper.description');
  },

  _addEvent: function (event) {
    BaseView.prototype.addEvent.apply(this, arguments);
  },

  initialize: function (options) {
    BaseView.prototype.initialize.call(this);

    this.width = options.width;
    this.design = options.design;
    this.isCustomFormat = options.isCustomFormat;

    UserInfoFactory.get().then(_.bind(function (userInfo) {
      this.canUse = hasRole('ROLE_PREMIUM')
        || INKIVE.Helpers.projectIsLinkedToRestrictions();

      this.render();
      this.initImageLoad();

      function hasRole (role) {
        return _(userInfo['roles']).contains(role);
      }
    }, this));
  },

  render: function () {
    BaseView.prototype.render.apply(this, arguments);
    this.$el.toggleClass('locked',
      this.design &&
      this.design['is_premium'] === '1' &&
      !this.canUse
    );

    INKIVE.Helpers.initTooltips(this.$el);
  },

  getTemplateRenderData: function () {
    var ratio = this.isCustomFormat
      ? this.canvas.contentW / this.canvas.contentH
      : this.design['format_width'] / this.design['format_height'];

    var thumbHeight = this.width * (1 / ratio);

    return {
      url: this.design['url'],
      can_use: this.canUse,
      show_options: true,
      show_lock_icon: this.design['is_premium'] === '1',
      thumb_height: Math.floor(thumbHeight)
    };
  },

  initImageLoad: function () {
    var isCustomFormat = this.isCustomFormat;
    var canvasRatio = this.canvas.contentW / this.canvas.contentH;

    this.$el.find('img').each(function () {
      this.onload = onImageLoad;
      this.src = $(this).data('src');
    });

    function onImageLoad () {
      var $image = $(this);
      $image.closest('.thumbnail.image')
        .removeClass('loading');

      if (isCustomFormat) {
        var imageRatio = this.naturalWidth / this.naturalHeight;
        var $thumbnail = $image.parent();

        $thumbnail.height($image.height()).addClass('custom');
        canvasRatio > imageRatio && $image.removeAttr('height');
      } else {
        $image.removeAttr('height');
      }
    }
  },

  setTemplate: function () {
    BaseView.prototype.setTemplate.apply(this, arguments);
    INKIVE.DesignFacade.set('template', {
      'keep_stage_size': this.isCustomFormat,
      'designed': { 'id': this.design['id'] }
    });
  },

  isSameSize: function () {
    return this.canvas.contentW == this.design['format_width']
      && this.canvas.contentH == this.design['format_height'];
  }
});
